import { CopyIon } from "../../../../../common/assets/JWayIcons";
import Button from "../../../../../common/components/atom/Button/Button";
import StatusBox from "../../../../../common/components/atom/StatusBox/StatusBox";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";
import { themeColorAppJs } from "../../../../../styles/theme/themeColor";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import SingleOrganization from "../../../../organization/components/SingleOrganization";
import { userRolesTraductor } from "../../../../user/types/user.types";
import useSingleCreateUserLink from "../../../hooks/useSingleCreateUserLink";
import { UCTStatut } from "../../../types/createUserLink.type";
export default function SingleCreateUserLinkInfo({
  culkId,
}: {
  culkId: string;
}) {
  const { singleCreateUserLinkQuery } = useSingleCreateUserLink(culkId);

  if (singleCreateUserLinkQuery.isLoading ) {
    return <LoaderSreen heigth="200px" />;
  }
  if (singleCreateUserLinkQuery.isError) {
    return <ErrorScreenApp axiosError={singleCreateUserLinkQuery.error}/>
  }

  return (
    <>
      <div style={{ height: 20 }} />
      <div style={{ color: "gray" }}>
        <p>
          {" "}
          Pour:{" "}
          <strong>
            {singleCreateUserLinkQuery.data?.uct_firstname}{" "}
            {singleCreateUserLinkQuery.data?.uct_lastname}
          </strong>
        </p>

        <p>
          {" "}
          Organisation:{" "}
      
            <strong>
            {singleCreateUserLinkQuery.data?.uct_organization_id ? (
              <SingleOrganization.Name
                organizationId={
                  singleCreateUserLinkQuery.data?.uct_organization_id
                }
              />
            ) : "Aucune"}
            </strong>

        </p>

        <p>
          {" "}
          Email: <strong>{singleCreateUserLinkQuery.data?.uct_email}</strong>
        </p>
        <p>
          {" "}
          Rôle:{" "}
          <strong>
            {userRolesTraductor(singleCreateUserLinkQuery.data?.uct_user_role)}
          </strong>
        </p>
        <p style={{ display: "flex" }}>
          {" "}
          Statut:{" "}
          <span style={{ marginLeft: 10 }}>
            {statusConverter(singleCreateUserLinkQuery.data?.uct_status)}
          </span>
        </p>

        <p>
          {" "}
          Lien: <strong>{singleCreateUserLinkQuery.data?.uct_link}</strong>
        </p>
        <div style={{ height: 20 }} />
        {singleCreateUserLinkQuery.data?.uct_link &&
          singleCreateUserLinkQuery.data?.uct_status === "ACTIVATED" && (
            <Button
              label="Copier le lien"
              onClick={() => {
                if (!navigator?.clipboard) {
                  alert(
                    "Désolé, Impossible de copier automatiquement le lien dans le presse-papier. \n\nVeuillez le copier manuellement le lien ci-dessous: \n\n" +
                      singleCreateUserLinkQuery.data?.uct_link
                  );
                  return;
                }
                navigator.clipboard
                  .writeText(singleCreateUserLinkQuery.data?.uct_link)
                  .then(() => {
                    alert("Lien copié dans le presse-papier");
                  })
                  .catch((err) => {
                    console.error("Erreur lors de la copie du lien :", err);
                    alert(
                      "Désolé, Impossible de copier automatiquement le lien dans le presse-papier. \n\nVeuillez le copier manuellement le lien ci-dessous: \n\n" +
                        singleCreateUserLinkQuery.data?.uct_link
                    );
                  });
              }}
              IconComponentRight={() => <CopyIon size={15} color="#fff" />}
            />
          )}
      </div>
    </>
  );
}

const statusConverter = (status: UCTStatut | undefined | null) => {
  if (status === null || status === undefined) {
    return <></>;
  }
  const size = { width: "80px", height: "20px", font: "0.8rem" };
  switch (status) {
    case "ACTIVATED":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.green.dark,
            background: themeColorAppJs.green.light,
          }}
        >
          Activé
        </StatusBox>
      );
    case "DESACTIVATED":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.red.dark,
            background: themeColorAppJs.red.light,
          }}
        >
          Désactivé
        </StatusBox>
      );
    case "CONSUMMATE":
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.gray.dark,
            background: themeColorAppJs.gray.light,
          }}
        >
          Consommé
        </StatusBox>
      );
    default:
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.gray.dark,
            background: themeColorAppJs.gray.light,
          }}
        >
          {status}
        </StatusBox>
      );
  }
};
